import { render, staticRenderFns } from "./scan copy 2.vue?vue&type=template&id=43220388&scoped=true&"
import script from "./scan copy 2.vue?vue&type=script&lang=js&"
export * from "./scan copy 2.vue?vue&type=script&lang=js&"
import style0 from "./scan copy 2.vue?vue&type=style&index=0&id=43220388&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43220388",
  null
  
)

export default component.exports